import Loadable from "components/Loadable";
import OPACLayout from "./components/OPACLayout";
import { lazy } from "react";
import ErrorBoundary from "routes/ErrorBoundary";

const Index = Loadable(lazy(() => import("features/opac/components/index")));
const MemberStatus = Loadable(
  lazy(
    () =>
      import("features/opac/components/MemberStatus/components/MemberStatus")
  )
);
const MaterialDetail = Loadable(
  lazy(
    () =>
      import(
        "features/opac/components/MaterialDetail/components/MaterialDetail"
      )
  )
);
// const MemberLogin = Loadable(
//   lazy(
//     () => import("features/opac/components/MemberLogin/components/MemberLogin")
//   )
// );

const OPACRoutes = {
  path: "/",
  errorElement: <ErrorBoundary />,
  children: [
    {
      path: "/",
      element: <OPACLayout />,
      children: [
        {
          path: "",
          element: <Index />,
        },
        {
          path: "memberDetail",
          element: <MemberStatus />,
        },
        {
          path: "information/:materialID?",
          element: <MaterialDetail />,
        },
        // {
        //   path: "login",
        //   element: <MemberLogin />,
        // },
      ],
    },
  ],
};

export default OPACRoutes;
